/**
 * useAchievementCount — Shared hook for counting unlocked achievements.
 *
 * Extracted from duplicated logic in Sidebar and MobileNav.
 * Single source of truth for achievement unlock counting in navigation UI.
 */

import { useMemo } from 'react';
import { useAppStore } from '../../app/hooks/useAppStore';
import { MODULES } from '../../content';
import { ACHIEVEMENTS } from '../../mascot/achievements/achievementData';
import { MODULE_MASTERED_THRESHOLD } from '../../config/constants';
export function useAchievementCount(): number {
  const {
    state,
    getModuleMasteryForGroup,
    getAnsweredQuestions
  } = useAppStore();
  return useMemo(() => {
    if (!state) return 0;
    const totalQs = MODULES.reduce((acc, m) => acc + getAnsweredQuestions(m.id).length, 0);
    const mastered = MODULES.filter(m => getModuleMasteryForGroup(m.id) >= MODULE_MASTERED_THRESHOLD).length;
    const checkData = {
      totalQuestionsAnswered: totalQs,
      masteredCount: mastered,
      level: state.stats?.level || 1,
      xp: state.stats?.xp || 0,
      currentWeekDays: state.dailyStreak?.currentWeekDays || 0,
      consecutiveFullWeeks: state.dailyStreak?.consecutiveFullWeeks || 0,
      longestTotalStreak: state.streak?.longestTotalStreak || 0,
      totalDailyGoalsReached: state.dailyStreak?.totalDailyGoalsReached || 0,
      totalPerfectSessions: state.dailyStreak?.totalPerfectSessions || 0
    };
    return ACHIEVEMENTS.filter(a => a.check(checkData)).length;
  }, [state, getAnsweredQuestions, getModuleMasteryForGroup]);
}